import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

enum CodeRequestTypes {
  sms = 'sms',
  voice = 'voice',
}

interface CodeRequest {
  type: CodeRequestTypes;
}

export default (makeCall: MakeCall) => (
  userId: number,
  { type }: CodeRequest,
) =>
  makeCall('POST', `${APIV2_URL}/user/${userId}/request-code`, {
    data: {
      type,
    },
  });
